export enum CLAIM_STATUS {
  DRAFT = 'DRAFT',
  REQUESTED = 'REQUESTED',
  REQUEST_SAVED = 'REQUEST_SAVED',
  PARTIAL_SETTLED = 'PARTIAL_SETTLED',
  SETTLED = 'SETTLED',
  REJECTED = 'REJECTED',
  OPEN = 'OPEN',
  BULK_SETTLED = 'BULK_SETTLED',
}

export enum RESPONSE_DECISION {
  SETTLE = 'SETTLE',
  REJECT = 'REJECT',
}

export enum CLAIM_TYPE {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export enum CLAIM_SETTLEMENT_STATUS {
  FULLY_SETTLED = 'FULLY_SETTLED',
  PARTIAL_SETTLED = 'PARTIAL_SETTLED',
}

export const CLAIMS_REFERENCE_SECTION = 'Claims';

export enum CLAIM_REFERENCE_CATEGORIES {
  CLAIM_TYPES = 'Claim Types',
  MEDICAL_CLAIM_TYPES = 'Medical Claim Types',
}

export enum CLAIM_CATEGORY {
  MEDICAL = 'MEDICAL',
  NON_MEDICAL = 'NON_MEDICAL',
  MOTOR = 'MOTOR',
  NON_MOTOR = 'NON_MOTOR',
}

export enum CLAIMS_BULK_FIELDS {
  BENEFICIARY_NAME = 'Beneficiary Name',
  BENEFICIARY_ID = 'Beneficiary Id',
  CLAIM_TYPE = 'Claim Type',
  VEHICLE_NUMBER = 'Vehicle Number',
  SURVEYOR_NAME = 'Surveyor Name',
  SURVEY_DATE = 'Survey Date (YYYY/MM/DD)',
  LOSS_DESCRIPTION = 'Loss Description',
  DATE_OF_LOSS = 'Date of Loss (YYYY/MM/DD)',
  CLAIM_CURRENCY = 'Claim Currency',
  CONVERSION_RATE = 'Conversion Rate',
  CLAIM_AMOUNT = 'Claim Amount',
  CLAIM_STATUS = 'Claim Status',
  INSURER_INTIMATION_NUMBER = 'Insurer Intimation Number',
  BROKER_INTIMATION_NUMBER = 'Broker Intimation Number',
  SETTLEMENT_CONVERSION_RATE = 'Settlement Conversion Rate',
  SETTLED_AMOUNT = 'Settled Amount',
  SETTLED_DATE = 'Settled Date (YYYY/MM/DD)',
  SETTLEMENT_REMARKS = 'Settlement Remarks',
  REJECTED_DATE = 'Rejected Date (YYYY/MM/DD)',
  REJECTED_REMARKS = 'Rejected Remarks',
  CLAIM_HANDLER = 'Claim Handler (Agent Code)',
  PAYEE_NAME = 'Payee Name',
  ACR_AMOUNT = 'ACR Amount',
  SUM_INSURED_OF_LOSS_CAT = 'Sum Insured of Loss Category',
  DEDUCTIBLES = 'Deductibles',
  LOSS_WITHIN_POLICY_EXCESS = 'Loss within Policy Excess',
  CH_REMARKS = 'Claim Handler Remarks',
  HOD_REMARKS = 'HOD Remarks',
  REMARKS = 'Remarks',
  CATEGORY = ' Category',
}
